export class User {
  constructor(name) {
    console.log(name + ' user created');
  }
}
